export const TOPIC_QUERY = topic => `topic: ${topic}`;
export const SOURCE_QUERY = source => `source: ${source}`;

export const TOPIC_HEADING_TRANSLATION_ID = 'topics';
export const SOURCE_HEADING_TRANSLATION_ID = 'sources';
